import { useEffect, useState } from "react"
import { type ISbStoryData } from "@storyblok/react"
import { getBreadcrumbStories } from "../utils/getBreadcrumbStories"
import { getStoryHref } from "../utils/getStoryHref"

export type StoryblokBreadCrumb = {
    href: string
    title: string
}

export function useStoryblokBreadcrumb({
    story,
    root,
}: {
    story: ISbStoryData
    root: StoryblokBreadCrumb
}) {
    const [crumbs, setCrumbs] = useState<StoryblokBreadCrumb[]>([])

    const getCrumbledStory = (story: ISbStoryData) => {
        return {
            href: getStoryHref(story),
            title: story.content.title,
        } satisfies StoryblokBreadCrumb
    }

    useEffect(() => {
        const fetchCrumbs = async () => {
            const stories: ISbStoryData[] = await getBreadcrumbStories(story.full_slug)
            // Root crumb is separately handled to mirror the state of OEFR Storyblok's space:
            // A section (Consumer-site, Blog, FAQ, Energy Games, ...) is coded, the inner stories are Storyblok-edited
            const crumbs = stories.map((story) => getCrumbledStory(story))
            crumbs.unshift(root)
            crumbs.push(getCrumbledStory(story))
            setCrumbs(crumbs)
        }

        void fetchCrumbs()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return crumbs
}
